export enum CSSUtils {
  fullWidthCol = 24,
  defaultSuiviVehiculeCol = fullWidthCol,
  lgSuiviVehiculeCol = 12,
  mediumWrapperCol = 4,
  mediumLargeWrapperCol = 6,
  largeWrapperCol = 8,
  LlargeWrapperCol = 10,
  XLargeWrapperCol = 12,
  //  global default
  defaultLabelCol = 13,
  defaultWrapperCol = largeWrapperCol,

  iconSize = '24px',
}
